<template>
  <enterprises-table :apiURL="apiURL" :title="name">
    <template>
      <back-button></back-button>
    </template>
    <template v-slot:button>
      <v-btn v-if="can('crear_empresa')" :color="themeColor" class="white--text" @click="associate()">Nueva Empresa</v-btn>
    </template>
  </enterprises-table>
</template>

<script>
import { mapGetters } from 'vuex';
import EnterprisesTable from '~/components/EnterprisesTable';
import BackButton from '~/components/BackButton';

export default {
  middleware: 'auth',
  props: {
    id: { default: null },
  },
  components: {
    EnterprisesTable,
    BackButton,
  },
  data: () => ({
    name: 'Empresas',
  }),
  computed: {
    apiURL() {
      return `/api/catalogs/dealers/${this.user.dealer_id}/enterprises`;
    },
    ...mapGetters({
      user: 'auth/user',
      themeColor: 'theme/themeColor',
    }),
  },
  methods: {
    associate() {
      this.$router.push({ path: `${this.$router.currentRoute.path}/agregar` });
    },
  },
};
</script>
